import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ScrollIntoView, Alert, Modal, RichTextArea } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { QuantityDiscountSelect, getFilteredQuantityDiscounts, divideEvenlyInTwo, getHighestMatchedDiscount } from '@grandvisionhq/fun-products';
import { Helpers } from '@grandvisionhq/inventory';
import { withIntl } from '@grandvisionhq/state';
import PrescriptionInfo from '../PrescriptionInfo/PrescriptionInfo.js';
import { getPriceForPack } from './helpers/get-price-for-pack.js';
import { pushSelectBoxQuantity } from './utils/data-layer.js';
import MonthlyPrice from './components/MonthlyPrice/MonthlyPriceContainer.js';
import PackageQuantity from './components/PackageQuantity/PackageQuantityContainer.js';
import Prescription from '../Prescription/ContactLenses/PrescriptionContainer.js';

class ConfigureContactLenses extends React.Component {
    componentDidMount() {
        this.setInitialPackSize(this.props.packageTypes[0]);
        this.setInitialSelectedDiscountItem();
    }
    showErrorAlert() {
        const { intl , formValidations  } = this.props;
        return /*#__PURE__*/ React.createElement(ScrollIntoView, {
            key: formValidations.errorCount
        }, /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            icon: "alert-circle"
        }, intl.getFormattedLabel('products.contactLenses.prescription.text', {
            parseLink: true
        })));
    }
    render() {
        var ref, ref1;
        const { attributes , prescriptionModalContent , intl , maxOrderableQuantity , allowBackOrder , isPrescriptionInfoEnabled , isPrescriptionExtraInfoEnabled , opticianForm , formValidations , prescriptionInfoAdditionalContent , variantData , packageTypes , isSubscriptionSelected , promotionalText , hasSubscriptions , quantityDiscountItems ,  } = this.props;
        const { leftEyeChecked , leftEyeBoxQuantity , leftEyeBoxAvailableQuantity , rightEyeChecked , rightEyeBoxQuantity , rightEyeBoxAvailableQuantity , packSize , prescriptionModalOpen ,  } = this.state;
        return /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator"
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, promotionalText && /*#__PURE__*/ React.createElement(Text, {
            variant: "body"
        }, promotionalText), isSubscriptionSelected ? /*#__PURE__*/ React.createElement(MonthlyPrice, null) : /*#__PURE__*/ React.createElement(PackageQuantity, {
            onChange: this.handlePackSizeChange,
            selectedSize: `${this.state.packSize}`,
            packageTypes: packageTypes
        }), quantityDiscountItems && /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__quantity-discounts"
        }, /*#__PURE__*/ React.createElement(QuantityDiscountSelect, {
            price: ((ref = this.state.packPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.centAmount) || 0,
            items: getFilteredQuantityDiscounts({
                leftEyeChecked: this.state.leftEyeChecked,
                rightEyeChecked: this.state.rightEyeChecked,
                quantityDiscountItems: this.props.quantityDiscountItems,
                maxOrderableQuantity: this.props.maxOrderableQuantity
            }),
            selectedValue: this.state.selectedDiscountItem,
            onChange: this.handleDiscountItemChange,
            currency: this.props.intl.currency
        })), /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__error-message"
        }, formValidations.showError && !formValidations.isConfiguratorValid && this.showErrorAlert()), /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__prescription"
        }, /*#__PURE__*/ React.createElement(Prescription, {
            isSubscriptionSelected: isSubscriptionSelected,
            hasSubscriptions: hasSubscriptions,
            isActive: rightEyeChecked,
            id: "right",
            onSelection: this.handleRightEyeChecked,
            quantity: rightEyeBoxQuantity,
            availableQuantity: rightEyeBoxAvailableQuantity,
            attributes: attributes,
            products: variantData,
            packSize: packSize,
            onFoundProduct: this.handleRightEyeProductSelection,
            onQuantityChange: this.handleRightEyeQuantity,
            "data-t": "prescription-right-eye",
            maxOrderableQuantity: maxOrderableQuantity,
            allowBackOrder: allowBackOrder,
            className: "contact-lens-configurator__prescription-column",
            hasError: formValidations.showError
        }), /*#__PURE__*/ React.createElement(Prescription, {
            isSubscriptionSelected: isSubscriptionSelected,
            hasSubscriptions: hasSubscriptions,
            isActive: leftEyeChecked,
            id: "left",
            onSelection: this.handleLeftEyeChecked,
            quantity: leftEyeBoxQuantity,
            availableQuantity: leftEyeBoxAvailableQuantity,
            attributes: attributes,
            products: variantData,
            packSize: packSize,
            onFoundProduct: this.handleLeftEyeProductSelection,
            onQuantityChange: this.handleLeftEyeQuantity,
            "data-t": "prescription-left-eye",
            maxOrderableQuantity: maxOrderableQuantity,
            allowBackOrder: allowBackOrder,
            className: "contact-lens-configurator__prescription-column",
            hasError: formValidations.showError
        })), prescriptionModalContent && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
            className: "contact-lens-configurator__prescription-link",
            onClick: this.onPrescriptionModalOpen
        }, intl.getLabel('products.contactLenses.prescription.link')), prescriptionModalOpen && /*#__PURE__*/ React.createElement(Modal, {
            showIcon: true,
            isOpen: prescriptionModalOpen,
            onModalClose: this.onPrescriptionModalClose
        }, /*#__PURE__*/ React.createElement("div", {
            className: "contact-lens-configurator__prescription-modal"
        }, /*#__PURE__*/ React.createElement(RichTextArea, {
            content: prescriptionModalContent
        })))), isPrescriptionInfoEnabled && /*#__PURE__*/ React.createElement(React.Fragment, null, formValidations.showError && !formValidations.isPrescriptionInfoValid && (formValidations.isConfiguratorValid ? /*#__PURE__*/ React.createElement(ScrollIntoView, {
            key: formValidations.errorCount
        }, /*#__PURE__*/ React.createElement(Alert, {
            icon: "info",
            message: intl.getLabel('products.contactLens.info.invalidMessage')
        })) : /*#__PURE__*/ React.createElement(Alert, {
            icon: "info",
            message: intl.getLabel('products.contactLens.info.invalidMessage')
        })), /*#__PURE__*/ React.createElement(PrescriptionInfo, {
            opticianForm: opticianForm,
            onChange: this.handlePrescriptionInfoChange,
            isPrescriptionExtraInfoEnabled: isPrescriptionExtraInfoEnabled,
            prescriptionInfoAdditionalContent: prescriptionInfoAdditionalContent
        }))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            selectedVariants: {},
            leftEyeChecked: true,
            leftEyeBoxQuantity: 1,
            prescriptionModalOpen: false,
            rightEyeChecked: true,
            rightEyeBoxQuantity: 1,
            packSize: 0
        };
        this.setInitialPackSize = ({ packageQuantity  })=>{
            packageQuantity && this.handlePackSizeChange(packageQuantity);
        };
        this.handleChange = (key, value)=>{
            const { handleFormChange  } = this.props;
            this.setState((prevState)=>swcHelpers.objectSpread({}, prevState, {
                    [key]: value
                })
            , ()=>handleFormChange && handleFormChange(this.state)
            );
        };
        this.handleLeftEyeChecked = (selection)=>{
            this.handleDiscountLogicOnSideChecked(selection, 'left');
            this.handleChange('leftEyeChecked', selection);
        };
        this.handleRightEyeChecked = (selection)=>{
            this.handleDiscountLogicOnSideChecked(selection, 'right');
            this.handleChange('rightEyeChecked', selection);
        };
        this.handleLeftEyeQuantity = (quantity)=>{
            this.handleDiscountLogicOnQuantityChange(quantity, 'left');
            this.handleChange('leftEyeBoxQuantity', quantity);
        };
        this.handleRightEyeQuantity = (quantity)=>{
            this.handleDiscountLogicOnQuantityChange(quantity, 'right');
            this.handleChange('rightEyeBoxQuantity', quantity);
        };
        /**
   * This function is used to handle the discount logic when the quantity of the box is changed
   * [@param](https://github.com/param) {number} quantity - The updated quantity.
   * [@param](https://github.com/param) {'right' | 'left'} side - The eye side being updated.
   */ this.handleDiscountLogicOnQuantityChange = (quantity, side)=>{
            let totalQuantity = quantity;
            if (this.state.leftEyeChecked && side === 'right') {
                totalQuantity += this.state.leftEyeBoxQuantity;
            }
            if (this.state.rightEyeChecked && side === 'left') {
                totalQuantity += this.state.rightEyeBoxQuantity;
            }
            this.findAndSetSelectedDiscountItem(totalQuantity);
        };
        /**
   * This function is used to handle the discount logic on component load
   */ this.setInitialSelectedDiscountItem = ()=>{
            let totalQuantity = 0;
            if (this.state.leftEyeChecked) {
                totalQuantity += this.state.leftEyeBoxQuantity;
            }
            if (this.state.rightEyeChecked) {
                totalQuantity += this.state.rightEyeBoxQuantity;
            }
            this.findAndSetSelectedDiscountItem(totalQuantity);
        };
        /**
   * This function is used to handle the discount logic when the side is checked
   * [@param](https://github.com/param) {boolean} selected - Whether the side is selected.
   * [@param](https://github.com/param) {'right' | 'left'} side - The eye side being updated.
   */ this.handleDiscountLogicOnSideChecked = (selected, side)=>{
            let totalQuantity = 0;
            const leftEyeChecked = selected && side === 'left' || side === 'right' && this.state.leftEyeChecked;
            const rightEyeChecked = selected && side === 'right' || side === 'left' && this.state.rightEyeChecked;
            if (leftEyeChecked) {
                totalQuantity += this.state.leftEyeBoxQuantity;
            }
            if (rightEyeChecked) {
                totalQuantity += this.state.rightEyeBoxQuantity;
            }
            this.findAndSetSelectedDiscountItem(totalQuantity, leftEyeChecked, rightEyeChecked);
        };
        /**
   * This function is used to handle the discount item change.
   * [@param](https://github.com/param) {number} discountItemValue - The value of the selected discount item.
   */ this.handleDiscountItemChange = (discountItemValue = 2)=>{
            const bothEyesChecked = this.state.leftEyeChecked && this.state.rightEyeChecked;
            if (bothEyesChecked) {
                const [boxQuantityLeft, boxQuantityRight] = divideEvenlyInTwo(discountItemValue);
                this.handleChange('leftEyeBoxQuantity', boxQuantityLeft);
                this.handleChange('rightEyeBoxQuantity', boxQuantityRight);
            } else if (this.state.leftEyeChecked) {
                this.handleChange('leftEyeBoxQuantity', discountItemValue);
            } else if (this.state.rightEyeChecked) {
                this.handleChange('rightEyeBoxQuantity', discountItemValue);
            }
            this.findAndSetSelectedDiscountItem(discountItemValue, this.state.leftEyeChecked, this.state.rightEyeChecked);
        };
        this.findAndSetSelectedDiscountItem = (quantity, leftEyeChecked, rightEyeChecked)=>{
            const matchedDiscount = getHighestMatchedDiscount(quantity, {
                leftEyeChecked: leftEyeChecked !== undefined ? leftEyeChecked : this.state.leftEyeChecked,
                rightEyeChecked: rightEyeChecked !== undefined ? rightEyeChecked : this.state.rightEyeChecked,
                quantityDiscountItems: this.props.quantityDiscountItems,
                maxOrderableQuantity: this.props.maxOrderableQuantity
            });
            this.handleChange('selectedDiscountItem', matchedDiscount === null || matchedDiscount === void 0 ? void 0 : matchedDiscount.discount.minimumQuantity);
        };
        this.handlePackSizeChange = (packSize)=>{
            var ref;
            let newPackSize;
            switch(typeof packSize){
                case 'string':
                    newPackSize = parseInt(packSize);
                    break;
                case 'number':
                    newPackSize = packSize;
                    break;
                case 'object':
                    newPackSize = +packSize.value;
                    break;
                default:
                    return;
            }
            this.setState({
                packPrice: getPriceForPack(newPackSize, this.props.packageTypes)
            }, ()=>this.handleChange('packSize', newPackSize)
            );
            this.state.packPrice && pushSelectBoxQuantity((ref = this.state.packPrice) === null || ref === void 0 ? void 0 : ref.value, this.state.dailiesUsageLevel, `${this.state.packSize}`);
        };
        this.handleProductSelection = (side, product)=>{
            this.setState({
                selectedVariants: swcHelpers.objectSpread({}, this.state.selectedVariants, {
                    [side]: product
                })
            });
            const skuKey = side === 'left' ? 'leftEyeBoxSKU' : 'rightEyeBoxSKU';
            const SKU = product && product.sku;
            this.handleChange(skuKey, SKU);
            const availableQuantityKey = side === 'left' ? 'leftEyeBoxAvailableQuantity' : 'rightEyeBoxAvailableQuantity';
            const availableQuantity = product && Helpers.getAvailableQuantity(product.availability);
            this.handleChange(availableQuantityKey, availableQuantity);
        };
        this.handleLeftEyeProductSelection = this.handleProductSelection.bind(this, 'left');
        this.handleRightEyeProductSelection = this.handleProductSelection.bind(this, 'right');
        this.setScroll = ()=>{
            const body = document && document.body;
            if (body) {
                this.state.prescriptionModalOpen && !body.classList.contains('body--no-scroll') ? body.classList.add('body--no-scroll') : body.classList.remove('body--no-scroll');
            }
        };
        this.onPrescriptionModalOpen = (event)=>{
            event.preventDefault();
            this.setState({
                prescriptionModalOpen: true
            }, ()=>{
                this.setScroll();
            });
        };
        this.onPrescriptionModalClose = ()=>{
            this.setState({
                prescriptionModalOpen: false
            }, ()=>{
                this.setScroll();
            });
        };
        this.handlePrescriptionInfoChange = (prescriptionState)=>{
            this.handleChange('prescriptionInfo', prescriptionState);
        };
    }
}
var ConfigureContactLenses$1 = withIntl(ConfigureContactLenses);

export { ConfigureContactLenses, ConfigureContactLenses$1 as default };
//# sourceMappingURL=ConfigureContactLenses.js.map
